import React, { Component } from 'react'
import { compose } from "redux"
import { withNamespaces } from "react-i18next"
import '../../i18n'
import StringHelper from '../../common/helpers/string_helper'
import './prefecture_property.scss'
import PropertyInformation from './property_information'
import ListingItem from './listing_item'

export class PrefectureProperty extends Component {
  render() {
    const {
      query,
      propertyId,
      prefecture,
      propertyTypes,
      roomGroups,
      isSP
    } = this.props

    const lang = languageHelper.pageLocale
    const propertyName = StringHelper.getPreferredLanguageString(roomGroups[0].property.title, lang)

    return (
      <React.Fragment>
        <div styleName="room-groups-wrapper" key={propertyId}>
          <div styleName="property-wrapper">

            <PropertyInformation propertyInfo={roomGroups[0].property}
              prefecture={prefecture} propertyId={propertyId} propertyName={propertyName} />

            <div styleName="room-groups">
              { this.props.roomGroups.map(roomGroup => (
                <ListingItem key={roomGroup.id}
                  lang={lang}
                  { ...roomGroup.property }
                  { ...roomGroup }
                  propertyTypes={propertyTypes}
                  checkin={query.checkin}
                  checkout={query.checkout}
                  adults={query.adults}
                  isSP={isSP}
                />
              )) }
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default compose(
  withNamespaces()
)(PrefectureProperty)
